import * as React from 'react';
import {PureComponent} from 'react';
import {dataControlStyle} from "./dataControlStyle";

export default class DatatableIcon extends PureComponent <any, any> {
    render() {
        return (
            <svg viewBox="0 0 200 200" style={{...dataControlStyle}}>
                <path className="st0" d="M137.09,107.14"/>
                <rect x="66.01" y="44.31" transform="matrix(6.123234e-17 -1 1 6.123234e-17 6.6088 181.4055)" className="st1" width="56" height="86.17"/>
                <line className="st0" x1="50.92" y1="69.59" x2="137.09" y2="69.59"/>
                <line className="st0" x1="51.99" y1="79.75" x2="138.16" y2="79.75"/>
                <line className="st0" x1="51.99" y1="88.37" x2="138.16" y2="88.37"/>
                <line className="st0" x1="51.99" y1="96.86" x2="138.16" y2="96.86"/>
                <line className="st0" x1="51.99" y1="107.14" x2="138.16" y2="107.14"/>
                <line className="st0" x1="72.8" y1="69.59" x2="72.8" y2="115.4"/>
                <line className="st0" x1="92.05" y1="69.59" x2="92.05" y2="115.4"/>
                <line className="st0" x1="114.57" y1="69.59" x2="114.57" y2="115.4"/>
            </svg>
        );
    }
}